/* eslint-disable no-new */
import * as utilDashboard from '@/api/dashboard'
const state = {
  transaksiPenjualanBulanIni: 0,
  transaksiPiutangBulanIni: 0,
  transaksiHutangBulanIni: 0,
  pelangganAktif: 0,
  transaksiPenjualan: 0,
  defecta: 0,
  stokHabis: 0,
  labaBersih: 0,
  labaKotor: 0,
  apiAppVersion: process.env.APP_VERSION,
  apiAppVersionChecked: 0,
  currentAppVersion: process.env.APP_VERSION
}
const mutations = {
  SET_apiAppVersion: (state, value) => {
    state.apiAppVersion = value
  },
  SET_apiAppVersionChecked: (state, value) => {
    state.apiAppVersionChecked = value
  },
  SET_currentAppVersion: (state, value) => {
    state.currentAppVersion = value
  },
  SET_TRANSAKSI_PENJUALAN_BULAN_INI: (state, numData) => {
    state.transaksiPenjualanBulanIni = numData
  },
  SET_TRANSAKSI_PIUTANG_BULAN_INI: (state, numData) => {
    state.transaksiPiutangBulanIni = numData
  },
  SET_TRANSAKSI_HUTANG_BULAN_INI: (state, numData) => {
    state.transaksiHutangBulanIni = numData
  },
  SET_PELANGGAN_AKTIF: (state, numData) => {
    state.pelangganAktif = numData
  },
  SET_TRANSAKSI_PENJUALAN: (state, numData) => {
    state.transaksiPenjualan = numData
  },
  SET_DEFECTA: (state, numData) => {
    state.defecta = numData
  },
  SET_STOK_HABIS: (state, numData) => {
    state.stokHabis = numData
  },
  SET_LABA_BERSIH: (state, numData) => {
    state.labaBersih = numData
  },
  SET_LABA_KOTOR: (state, numData) => {
    state.labaKotor = numData
  }
}
const actions = {
  apiAppVersionCheckedAction({ commit }, value) {
    commit('SET_apiAppVersionChecked', value)
  },
  androidInofarmaVersion({ commit }) {
    return new Promise((resolve, reject) => {
      utilDashboard.androidInofarmaVersion().then(response => {
        const { data } = response
        commit('SET_apiAppVersion', data.source_code_version)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  grandTotalPenjualanBulanIni({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.grandTotalPenjualanBulanIni().then(response => {
        const {
          data
        } = response
        commit('SET_TRANSAKSI_PENJUALAN_BULAN_INI', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  grandTotalPiutangBulanIni({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.grandTotalPiutangBulanIni().then(response => {
        const {
          data
        } = response
        commit('SET_TRANSAKSI_PIUTANG_BULAN_INI', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  grandTotalHutangJatuhTempoBulanIni({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.grandTotalHutangJatuhTempoBulanIni().then(response => {
        const {
          data
        } = response
        commit('SET_TRANSAKSI_HUTANG_BULAN_INI', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalPelangganAktif({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.totalPelangganAktif().then(response => {
        const {
          data
        } = response
        commit('SET_PELANGGAN_AKTIF', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalTransaksiPenjualan({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.totalTransaksiPenjualan().then(response => {
        const {
          data
        } = response
        commit('SET_TRANSAKSI_PENJUALAN', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalDefecta({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.totalDefecta().then(response => {
        const {
          data
        } = response
        commit('SET_DEFECTA', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalNoStockNoExpired({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.totalNoStockNoExpired().then(response => {
        const {
          data
        } = response
        commit('SET_STOK_HABIS', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalLabaBersih({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.totalLabaBersih().then(response => {
        const {
          data
        } = response
        commit('SET_LABA_BERSIH', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  totalLabaKotor({
    commit
  }) {
    return new Promise((resolve, reject) => {
      utilDashboard.totalLabaKotor().then(response => {
        const {
          data
        } = response
        commit('SET_LABA_KOTOR', data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js